import React, { useState } from "react";
import quizImg from "../Assets/img/misc/quiz-img.jpeg";
import quizBg from "../Assets/img/misc/quiz-bg.png";
import Navbar from "../components/Navbar";

function Quiz() {
	let [quizVal, setQuizVal] = useState(true);
	return (
		<>
			<Navbar />
			<br />
			<br />
			<br />

			{quizVal ? (
				<div>
					<h1
						style={{
							margin: "auto",
							display: "block",
							textAlign: "center",
							color: "white",
							fontFamily: "Poppins-Bold",
							position: "relative",
							top: "20%",
							fontSize: "70px",
						}}
					>
						MASTER-STROKE
					</h1>

					<h1
						style={{
							margin: "auto",
							display: "block",
							textAlign: "center",
							color: "white",
							fontWeight: "bold",
							position: "relative",
							top: "30%",
							fontSize: "45px",
						}}
					>
						Think & Act Fast
					</h1>
					{/* <img
            style={{
              display: "block",
              position: "relative",
              margin: "auto",
              height: "500px",
              width: "350px",
              top: "20px",
              marginBottom: "50px",
            }}
            src={quizImg}
          /> */}
					<button
						class="enrollbtn"
						onClick={() => {
							setQuizVal(!quizVal);
						}}
						style={{
							display: "block",

							margin: "auto",
							color: "white",
							position: "relative",
							top: "35%",
							//   marginBottom: "50px",
						}}
					>
						Start the Quiz!
					</button>
				</div>
			) : (
				<div>
					<iframe
						src="https://app.sli.do/event/eventhash"
						height="100%"
						width="100%"
						style={{ minHeight: "860px" }}
					></iframe>
				</div>
			)}
		</>
	);
}

export default Quiz;
